import React, { Component } from 'react';

/**
 * Legenda do mapa — paridade com GeoReferenciamentoMapa/{LegendaUsers,Legenda}.jsx.
 *
 * Os ícones de empreendimento vêm de `route('building-markers')`
 * (BuildingIconsForMapController → App\BuildingIcons), que é config PHP estática:
 * nenhuma dependência de MongoDB.
 */
class GeoLegend extends Component {
    state = { markers: [] };

    componentDidMount() {
        this.loadMarkers();
    }

    loadMarkers = async () => {
        try {
            const response = await axios.get(route('building-markers'));
            this.setState({ markers: response.data || [] });
        } catch (e) {
            console.error('[GeoLegend] erro ao carregar a legenda de marcadores:', e);
        }
    };

    render() {
        const { interestColor } = this.props;

        return (
            <div className="geo-legend">
                <table className="table table-striped table-condensed legenda-mapa">
                    <tbody>
                        <tr>
                            <td><img src="/img/markers/masc.png" alt="" /></td>
                            <td>Usuário masculino</td>
                        </tr>
                        <tr>
                            <td><img src="/img/markers/fem.png" alt="" /></td>
                            <td>Usuário feminino</td>
                        </tr>
                        <tr>
                            <td>
                                <span
                                    className="geo-legend-interest"
                                    style={{ backgroundColor: interestColor, borderColor: interestColor }}
                                />
                            </td>
                            <td>Imóvel de interesse de algum usuário</td>
                        </tr>
                        <tr>
                            <td><span className="geo-legend-bairro" /></td>
                            <td>Limite de bairro</td>
                        </tr>
                        {this.state.markers.map((marker) => (
                            <tr key={`${marker.tipo}-${marker.padrao}-${marker.status}`}>
                                <td><img src={marker.icon} alt="" /></td>
                                <td>{`${marker.tipo} ${marker.padrao} ${marker.status}`}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default GeoLegend;
